import React, { useState } from 'react';
import { Typography } from 'fronton-react';
import { useSelector } from 'react-redux';
import { optionButtons, tintingOptions } from 'data';
import { Container } from 'common/components';
import { WindowTypes, selectWindowType } from 'store/pageStore';
import { checkScreenType } from 'utils';
import { ButtonsList } from '../buttons-list';
import { CardsList } from '../cards-list';
import { optionsHeaderStyles } from './styles';

export const OptionsContainer = () => {
	const [selectedOption, setSelectedOption] = useState(optionButtons[0].optionName);
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);
	return (
		<Container style={{ overflow: 'hidden' }}>
			<Typography
				className={optionsHeaderStyles}
				variant={isMobile ? 'h2' : 'h1'}
				as="h2"
				overrideStyles={false}
			>
				Что можно заколеровать
			</Typography>
			<ButtonsList
				value={selectedOption}
				onChange={setSelectedOption}
				optionButtons={optionButtons}
			/>
			<CardsList mobile={isMobile} value={selectedOption} tintingOptions={tintingOptions} />
		</Container>
	);
};
